import React from 'react';

interface SettingsCategoryProps {
    title: string;
    description: string;
    isExpanded: boolean;
    onToggle: () => void;
    children: React.ReactNode;
}

const SettingsCategory: React.FC<SettingsCategoryProps> = ({
    title,
    description,
    isExpanded,
    onToggle,
    children
}) => (
    <div className="rounded-xl border border-gray-200 bg-white">
        <button
            onClick={onToggle}
            className="w-full flex items-center justify-between px-5 py-4 group"
        >
            <div className="flex flex-col items-start">
                <h4 className="text-base font-semibold text-gray-700">{title}</h4>
                <span className="text-xs text-gray-500">{description}</span>
            </div>
            <svg
                className={`w-5 h-5 text-gray-400 transition-transform duration-300 ease-out ${isExpanded ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </button>
        <div
            className={`grid transition-all duration-300 ease-out ${
                isExpanded ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
            }`}
        >
            <div className="overflow-hidden">
                <div className="px-5 pb-5">
                    <div className="h-px bg-gray-200 mb-5" />
                    {children}
                </div>
            </div>
        </div>
    </div>
);

export default SettingsCategory;
